import React, { useState, useEffect } from 'react';
import ActionButtonCard from '../Button/ActionButtonCard';
import Swal from 'sweetalert2'
import { Form, Button, Card, InputGroup, FormControl } from 'react-bootstrap';
import { useProvider, Toast } from '../../context/MenuProvider';

function SelecionarMarca({marcaId, label, setMarcaId}) {
  const [marcas, setMarcas] = useState([]);
  const {
    crud,
    buscarDados,
    salvarDados,
  } = useProvider();
  const { get, post } = crud || {};
  
  const addMarca = async(e) => {
        if(e) e.preventDefault();
        const nome_da_marca = prompt(`Novo(a) ${label || 'Marca:'}`);
        if (!nome_da_marca) return;
        try{
          const dataForm ={
            nome_da_marca,
          }
          const response = await post(dataForm, `/gvendas/marcas/`, null, 'nova-marca');
            if(response && response.length){
              setMarcas((prev)=>([
                ...response,
                ...prev
            ]));
            await salvarDados("db_marcas", response)
          }
        }catch(err){
          alert(JSON.stringify(err.response.data || err.response))
        }
  }
  

  const buscarMarcasLocal = async () => {
    try{
      const response = await buscarDados(
        "db_marcas",
        (item) => {
          return true
        },
        100,
        "nome_da_marca"
      );
      if(response && response.length){
        setMarcas(response);
      }
    }catch(err){
      
    }finally{
      buscarMarcas();
    }
  };
  const buscarMarcas = async () => {
    try{
      const response = await get(`/gvendas/marcas/?ordering=nome_da_marca`, 'SelecionarMarca');
      if(response && response.length){
        setMarcas(response[0].results);
        await salvarDados("db_marcas", response[0].results)
      }
    }catch(err){
      
    }
  };

  useEffect(() => {
    buscarMarcasLocal();
  }, [setMarcas]);

  return (
    <>
      <Form.Group controlId="formMarca" className="mt-3">
        <div className="input-group">
          <span className="input-group-text">{label || 'Marca'}</span>
          <Form.Control 
            as="select" 
            value={marcaId} 
            onChange={(e) => setMarcaId(e.target.value)}
          >
            {/* Supondo que você tenha um array de marcas para mapear */}
            <option value="">Selecione {label?.toLowerCase() || "marca"}</option>
            {/* Categorias mapeadas aqui */}
            {marcas.length > 0 ? (marcas.map((item) => 
              <option value={item.id}>{item.nome_da_marca}</option>
            )) : ''}
          </Form.Control>
          <Button variant="secondary" onClick={addMarca}>Novo</Button>
        </div>
      </Form.Group>
    </>
  );
}

export default SelecionarMarca;